<template>
  <section id="home" class="hero-carousel">
    <!-- 轮播容器 -->
    <div class="carousel">
      <!-- 轮播图片 -->
      <div class="slides" :style="slideStyle">
        <div class="slide" v-for="(slide, index) in slides" :key="index">
          <img :src="(slide.image)" :alt="slide.alt" class="slide-image" loading="lazy">
          <div class="slide-overlay"></div>
          <div class="slide-content">
            <h2  class="slide-title">{{ slide.title }}</h2>
            <p  class="slide-description">{{ slide.description }}</p>
            <!-- <a v-if="slide.buttonText" :href="slide.buttonLink" class="slide-button">
              {{ slide.buttonText }}
            </a> -->
          </div>
        </div>
      </div>

      <!-- 轮播指示器 -->
      <div class="indicators">
        <button v-for="(slide, index) in slides" :key="index" @click="goToSlide(index)"
          :class="{ 'active': currentIndex === index }" :aria-label="`跳转到轮播项 ${index + 1}`"></button>
      </div>

      <!-- 导航按钮 -->
      <button class="nav-button prev" @click="prevSlide" aria-label="上一个">
        <svg viewBox="0 0 24 24">
          <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
        </svg>
      </button>
      <button class="nav-button next" @click="nextSlide" aria-label="下一个">
        <svg viewBox="0 0 24 24">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        </svg>
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

// 轮播数据
const slides = ref([
  {
    image: require('@/assets/images/智能办公·高效未来.jpg'),
    alt: '',
    title: '智能办公·高效未来',
    description: '一站式企业服务解决方案，助力团队协作与效率提升',
    buttonText: '免费试用',
    buttonLink: '#'
  },
  {
   image: require('@/assets/images/数据驱动·决策无忧.jpg'),
    alt: '',
    title: '数据驱动·决策无忧',
    description: '企业级数据分析平台，精准洞察业务增长点',
    buttonText: '查看演示',
    buttonLink: '#'
  },
  {
    image: require('@/assets/images/数字化流程管理.jpg'),
    alt: '',
    title: '数字化流程管理',
    description: '自动化工作流，提升企业运营效率',
    buttonText: '了解安全',
    buttonLink: '#'
  }
])

const currentIndex = ref(0)
let autoPlayInterval = null
let pauseAutoPlay = false

// 计算轮播位置样式
const slideStyle = computed(() => {
  return {
    transform: `translateX(-${currentIndex.value * 100}%)`
  }
})

// 下一张
const nextSlide = () => {
  currentIndex.value = (currentIndex.value + 1) % slides.value.length
  resetAutoPlay()
}

// 上一张
const prevSlide = () => {
  currentIndex.value = (currentIndex.value - 1 + slides.value.length) % slides.value.length
  resetAutoPlay()
}

// 跳转到指定幻灯片
const goToSlide = (index) => {
  currentIndex.value = index
  resetAutoPlay()
}

// 自动播放
const startAutoPlay = () => {
  autoPlayInterval = setInterval(() => {
    if (!pauseAutoPlay) {
      nextSlide()
    }
  }, 5000)
}

// 重置自动播放
const resetAutoPlay = () => {
  clearInterval(autoPlayInterval)
  startAutoPlay()
}



// 初始化自动播放
onMounted(() => {
  startAutoPlay()
})

// 清除定时器
onUnmounted(() => {
  clearInterval(autoPlayInterval)
})
</script>

<style scoped>
.hero-carousel {
  position: relative;
  width: 100%;
  height: 80vh;
  max-height: 800px;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides {
  display: flex;
  transition: transform 0.6s ease-in-out;
  width: 100%;
  height: 100%;
}

.slide {
  position: relative;
  min-width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  background: linear-gradient(to right,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.3) 100%);
}

.slide-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1200px;
  text-align: center;
  color: white;
  z-index: 2;
  padding: 0 20px;
}

.slide-title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 0.8s ease;
}

.slide-description {
  font-size: clamp(1rem, 2vw, 1.5rem);
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 0.8s ease 0.2s both;
}

.slide-button {
  display: inline-block;
  padding: 12px 30px;
  color: white;
  text-decoration: none;
  border-radius: var(--border-radius);
  font-weight: 600;
  transition: var(--transition);
  border: 2px solid var(--primary);
  font-size: 1rem;
  box-shadow: var(--shadow);
  animation: fadeInUp 0.8s ease 0.4s both;
  background-color: transparent;
  color: white;
  border-color: white;
  box-shadow: var(--shadow-hover);
}

.slide-button:hover {
  background-color: var(--primary);
  border: 2px solid var(--primary);
  transform: translateY(-3px);

}

/* 轮播指示器 */
.indicators {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.indicators button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
}

.indicators button.active {
  background-color: var(--primary);
  transform: scale(1.2);
}

/* 导航按钮 */
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}



.nav-button svg {
  width: 48px;
  height: 48px;
  fill: white;
}

.prev {
  left: 30px;
}

.next {
  right: 30px;
}

/* 动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-carousel {
    height: 70vh;
  }

  .slide-content {
    width: 95%;
  }

  .nav-button {
    width: 40px;
    height: 40px;
  }

  .nav-button svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 768px) {
  .hero-carousel {
    height: 60vh;
  }

  .indicators {
    bottom: 20px;
  }

  .indicators button {
    width: 10px;
    height: 10px;
  }

  .prev {
    left: 15px;
  }

  .next {
    right: 15px;
  }
}

@media (max-width: 576px) {
  .hero-carousel {
    height: 50vh;
  }

  .slide-title {
    margin-bottom: 1rem;
  }

  .slide-description {
    margin-bottom: 1.5rem;
    /* display: none; */
    /* 在小屏幕上隐藏描述 */
  }

  .slide-button {
    padding: 10px 20px;
  }

  .indicators button {
    width: 8px;
    height: 8px;
  }
}
</style>